import React, { useContext } from "react";
import { Card, CardHeader, Typography, Avatar } from "@mui/material";
import { green } from "@mui/material/colors";
import { Person } from "@mui/icons-material";
import { LayoutContext } from "wcz-layout";

export default function SelfConfirmAttendeeCard() {
    const { user } = useContext(LayoutContext);

    return (
        <Card square elevation={3} sx={{ display: "flex", flexDirection: "column", m: "4px" }}>
            <Typography sx={{ fontSize: 14, pl: "15px", pt: "5px" }} color="text.secondary">
                Confirm Attendee:
            </Typography>

            <CardHeader
                avatar={
                <Avatar sx={{ bgcolor: green[500] }}>
                    <Person />
                </Avatar>
                }                
                title={user.name + " (" + user.id + ")"}
                subheader={user.department}
            />
        </Card>
    );
}